export default __webpack_public_path__ + "static/media/workshop.711853ee.png";